import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { ToastContainer, toast } from 'react-toastify';

import PageContainer from '../../../myComponents/pageContainer';
import PageLoader from '../../../myComponents/loaders/pageLoader';
import { viewAllClientLabels } from '../../../config/recentCards';
import useViewportWidth from '../../../myHooks/useViewportWidth';
import ClientsRecentCard from '../../../myComponents/recentView/clientsRecentCard';
import UserDropdownHeader from '../../../myComponents/userDropdownHeader';
import Watermark from '../../../myComponents/watermark';
import { fetchOwnedAgencyData, removeOwnedAgencyData } from '../../../redux/actions/Data';

const useStyles = makeStyles(theme => ({
  mainContainer: {
    width: '95%',
    margin: '30px auto 50px auto',
  },
}));

const ClientsViewAll = () => {
  const classes = useStyles();
  const viewportWidth = useViewportWidth();
  const appData = useSelector(({ data }) => data);
  const dispatch = useDispatch();

  const [pageIsLoading, setPageIsLoading] = useState(true);

  useEffect(() => {
    if (!appData.loading) {
      if (appData.error) {
        showToastWarn();
      } else {
        setPageIsLoading(false);
      }
    }
  }, [appData]);

  const showToastWarn = () => {
    toast.warn('Something went wrong, please try again later.', {
      position: 'bottom-right',
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const activateClientHandler = (isRemove, agencyId) => {
    if (appData.loadingAgencyData) return;

    if (isRemove) {
      dispatch(removeOwnedAgencyData(agencyId));
    } else {
      dispatch(fetchOwnedAgencyData(agencyId));
    }
  };

  const cardSize = viewportWidth < 530 ? 'small' : viewportWidth < 880 ? 'medium' : 'big';
  const labels = viewAllClientLabels(cardSize);

  return (
    <Box position="relative" height="100%">
      <UserDropdownHeader bgColor="#f4f4f7" />
      <PageContainer
        headingStyle={{
          fontWeight: 'bold',
          margin: '25px 0 0 25px',
        }}
        style={{
          position: 'relative',
        }}>
        {pageIsLoading ? (
          <PageLoader />
        ) : (
          <Box className={classes.mainContainer}>
            <ClientsRecentCard
              heading="Clients"
              listSections={labels}
              clients={appData.ownedAgencyStats}
              visibleAgencies={appData.visibleAgencies}
              activateClient={activateClientHandler}
              cardSize={cardSize}
              isLoading={appData.loading}
              loadingAgencyData={appData.loadingAgencyData}
            />

            <ToastContainer
              theme="colored"
              position="bottom-right"
              autoClose={4000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </Box>
        )}
      </PageContainer>
      <Box position="absolute" bottom="10px" display="flex" justifyContent="center" width="100%">
        <Watermark />
      </Box>
    </Box>
  );
};

export default ClientsViewAll;
